export default class QueryOrderByType
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryOrderByType";

	static ASC = "ASC";
	static DESC = "DESC";
		
	static valueOf(value)
	{
		if(value == "ASC")
			return QueryOrderByType.ASC;
		else if(value == "DESC")
			return QueryOrderByType.DESC;
		
		throw new Error("枚举类型错误");
	}

}


// WEBPACK FOOTER //
// ./src/query/remote/QueryOrderByType.js